import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import config from "../../../../secrets/config";
import moment from "moment";
import telematicsService from "../../../api/telematics.service";
import alertService from "../../../api/alertConfiguration.service";
export default {
  name: "alert-management-list",
  components: { pageheader },
  data() {
    // BE-1118: the list opens from 7 days ago through today. Both dates
    // are UTC days from one clock read (birch-telematics-api's
    // AlertsListService.BuildFilteredQueryAsync filters on UTC days,
    // AlertsListService.cs:498-508), and clearDates, clearFilters and the
    // Remove From/To Dates icon reuse them.
    const nowDate = new Date().toISOString().slice(0, 10);
    const defaultFromDate = moment
      .utc(nowDate)
      .subtract(7, "days")
      .format("YYYY-MM-DD");
    return {
      configdata: config.ENABLE_ACCESS_CODE,
      input: {},
      fromDate: defaultFromDate,
      toDate: nowDate,
      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      countLables: [
        {
          name: "25",
          count: 25,
        },
        {
          name: "50",
          count: 50,
        },
        {
          name: "100",
          count: 100,
        },
        {
          name: "ALL",
          count: -1,
        },
      ],
      totalRecordsCount: 0,
      sortBy: "",
      sortOrder: "",
      nowDate: nowDate,
      defaultFromDate: defaultFromDate,
      menu1: false,
      menu2: false,
      groups: [],
      locations: [],
      selectedGroup: [],
      selectedJobSite: [],
      selectedEventType: [],
      selectedSeverity: [],
      selectedStatus: [],
      groupSearchFilter: "",
      jobSiteSearchFilter: "",
      eventTypeSearchFilter: "",
      severitySearchFilter: "",
      statusSearchFilter: "",
      searchMenu: false,
      searchField: "",
      menufilter: false,
      loadingGroups: false,
      loadinglocations: false,
      isExcelLoading: false,
      isAlertsLoading: false,

      selected: [
        "Dates",
        "Group",
        "Jobsite",
        "EventType",
        "Severity",
        "Status",
        "Equipment #",
      ],
      filterTypes: [
        { id: "1", name: "Dates" },
        { id: "2", name: "Group" },
        { id: "3", name: "Jobsite" },
        { id: "4", name: "EventType" },
        { id: "5", name: "Severity" },
        { id: "6", name: "Status" },
        { id: "7", name: "Equipment #" },
      ],
      filterTypesWithoutAccess: [
        { id: "1", name: "Dates" },
        { id: "4", name: "Group" },
        { id: "5", name: "Jobsite" },
        { id: "6", name: "EventType" },
        { id: "7", name: "Severity" },
        { id: "8", name: "Status" },
        { id: "9", name: "Equipment #" },
      ],
      eventListTypes: [],
      severityOptions: [
        { name: "Critical" },
        { name: "Normal" },
        { name: "Low" },
      ],
      statusOptions: [{ name: "Open" }, { name: "Closed" }],
      headers: [
        { text: "Actions", value: "action", sortable: false },
        { text: "Date", value: "alertDateTime", align: "center" },
        { text: "Severity", value: "severity" },
        // eventType and rentalStatus are resolved after the page is fetched (from
        // AL_Events and Mongo respectively), so the server cannot order by them —
        // leaving them sortable showed a sort arrow that changed nothing.
        { text: "Event Type", value: "eventType", sortable: false },
        { text: "Alert Name", value: "alertName" },
        { text: "Alert Status", value: "status" },
        { text: "Equipment #", value: "equipmentName" },
        { text: "Description", value: "equipmentDescription", sortable: false },
        { text: "Status", value: "rentalStatus", sortable: false },
      ],
      alertsList: [],
      severityType: [
        {
          name: "Critical",
          textcolorCode: "#D15A3A",
          icon: "mdi-close-circle",
        },
        { name: "Normal", textcolorCode: "#5187E6", icon: "mdi-alert-circle" },
        { name: "Low", textcolorCode: "#5EBF74", icon: "mdi-information" },
      ],
    };
  },
  computed: {
    ...mapGetters(["roles"]),
    startPageCount() {
      return this.pageNumber == -1
        ? 1
        : (this.pageNumber - 1) * this.pageSize + 1;
    },
    endPageCount() {
      return this.pageNumber == -1 || this.pageNumber == 1
        ? this.alertsList.length
        : (this.pageNumber - 1) * this.pageSize + this.alertsList.length;
    },
  },
  mounted() {
    // getting input content

    this.input = utils.getInputContent("alertmanagement", this.roles);
    this.getGroups();
    this.getLocations();
    this.getEvents();
    this.getAlerts();
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
  },
  methods: {
    // Argument list shared by fetchAlertsData and excelDownload, which take
    // the same twelve parameters in the same order.
    alertsQueryArgs() {
      const groupIds =
        this.selectedGroup.length > 0 ? this.selectedGroup.join(",") : "";
      const jobSite =
        this.selectedJobSite.length > 0 ? this.selectedJobSite.join(",") : "";
      const eventTypes =
        this.selectedEventType.length > 0
          ? this.selectedEventType.join(",")
          : "";
      return [
        this.fromDate,
        this.toDate,
        groupIds,
        jobSite,
        eventTypes,
        this.selectedSeverity,
        this.selectedStatus,
        this.searchField,
        this.pageNumber,
        this.pageSize,
        this.sortBy,
        this.sortOrder,
      ];
    },
    async exportAlertsToExcel() {
      this.isExcelLoading = true;
      const response = await alertService.excelDownload(
        ...this.alertsQueryArgs()
      );
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response]), {
          type: "application/vnd.ms-excel",
        });
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Alerts.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        // deferred a tick: revoking in the same tick as click() can abort the
        // download in Firefox and Safari
        setTimeout(() => window.URL.revokeObjectURL(url), 0);
        this.isExcelLoading = false;
      } else {
        this.isExcelLoading = false;
        this.$toast.error("Unable to export Alerts to Excel");
      }
    },
    sortByTable(val1) {
      if (val1 == undefined) {
        this.sortBy = "";
      } else {
        this.sortBy = val1;
      }
    },
    sortTableOrder(val) {
      if (val == undefined) {
        this.sortOrder = "";
      } else if (val == true) {
        this.sortOrder = "DESC";
      } else if (val == false) {
        this.sortOrder = "ASC";
      }
      this.getAlerts();
    },
    pageChange() {
      this.getAlerts();
    },
    goToFirstPage() {
      this.pageNumber = 1;
      this.getAlerts();
    },
    goToLastPage() {
      this.pageNumber = this.totalRecords;
      this.getAlerts();
    },
    clearSearch() {
      // Handles @click:clear so the template binding resolves. Vuetify's
      // clearable sets the model to null right after this runs; that is fine,
      // since buildQuery sends null as an empty search.
      this.searchField = "";
    },
    filterData() {
      // Enter mirrors the adjacent search button, including its disabled rule.
      if (!this.fromDate || !this.toDate || !this.searchField) {
        return;
      }
      this.searchMenu = false;
      // A narrower search can have fewer pages than the one being viewed.
      this.goToFirstPage();
    },
    async getAlerts() {
      // Built before the try, as the inlined version was, so that a throw
      // from either join still escapes rather than hitting the catch below.
      const queryArgs = this.alertsQueryArgs();
      try {
        this.isAlertsLoading = true;
        const response = await alertService.fetchAlertsData(...queryArgs);
        if (response) {
          this.totalRecordsCount = response.totalRecords;
          let totalRecords = Math.ceil(this.totalRecordsCount / this.pageSize);
          if (this.pageSize == -1) {
            this.totalRecords = 1;
          } else {
            this.totalRecords = parseInt(totalRecords);
          }
          this.alertsList = response.data;
          this.isAlertsLoading = false;
        } else {
          this.alertsList = [];
          this.isAlertsLoading = false;
        }
      } catch (error) {
        this.alertsList = [];
        this.isAlertsLoading = false;
        this.$toast.error("Unable to get Alerts");
      }
    },
    viewAlert(item) {
      this.$router.push({
        path: `/alert-management/view/${item.id}`,
      });
    },
    getTextColorCode(severityName) {
      const titleCaseSeverity =
        severityName.charAt(0).toUpperCase() +
        severityName.slice(1).toLowerCase();
      const severity = this.severityType.find(
        (type) => type.name === titleCaseSeverity
      );
      return severity ? severity.textcolorCode : "#0011de"; // Default color
    },
    async getGroups() {
      try {
        this.loadingGroups = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              group: String(index),
            };
          });

          this.loadingGroups = false;
        }
      } catch (err) {
        this.loadingGroups = false;
        console.log(err);
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.locations = response.data.filter((e) => e.locationName != null);
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },
    jobsiteDisplay(item) {
      return `${item.locationName} (${item.locationId})`;
    },
    async getEvents() {
      try {
        const response = await alertService.fetchEvents();
        if (response && response.data) {
          this.eventListTypes = response.data;
        }
      } catch (error) {
        console.log(error);
      }
    },

    clearDates() {
      // Reset to the same default the page mounts with, not to an empty
      // range: an empty range leaves Search disabled and sends a blank
      // fromDate/toDate to the API.
      this.fromDate = this.defaultFromDate;
      this.toDate = this.nowDate;
    },
    resetGroup() {
      this.selectedGroup = [];
      this.alertsList = [];
    },
    resetJobSite() {
      this.selectedJobSite = [];
    },
    resetSeverity() {
      this.selectedSeverity = [];
    },
    resetStatus() {
      this.selectedStatus = [];
    },
    resetEventType() {
      this.selectedEventType = [];
    },
    clearFilters() {
      this.fromDate = this.defaultFromDate;
      this.toDate = this.nowDate;
      this.selectedGroup = [];
      this.selectedJobSite = [];
      this.searchField = "";
      this.selectedEventType = [];
      this.selectedSeverity = [];
      this.selectedStatus = [];
      this.goToFirstPage();
    },
  },
};
